const Texto = ({ className, children }) => {
  return <p className={'text-base ' + className}>{children}</p>
}

export default Texto
